<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-5" cols="12">
                <v-btn
                    v-if="inEditMode && documentChecklist.id != 0 && !placement.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="editClick()"
                >
                    <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.lock') }}
                </v-btn>
                <v-btn
                    v-if="!inEditMode && !placement.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="editClick()"
                >
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
            </v-col>
            <v-col class="pl-5">
                <v-btn
                    v-if="inEditMode && documentChecklist.id != 0 && !placement.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="pullDocuments(null)"
                >
                    <v-icon small>fas fa-file-import</v-icon>&nbsp;{{ $t('buttons.pullDocuments') }}
                </v-btn>
            </v-col>
            <v-col class="pl-5 text-right">
                <v-btn
                    v-if="inEditMode && !placement.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="updateList(null)"
                >
                    <v-icon small>fas fa-sync</v-icon>&nbsp;{{ $t('buttons.updateList') }}
                </v-btn>
                <v-col v-if="updated != ''" class="pl-5 text-right">
                    {{ $t('labels.checklistLastUpdated') }} {{ updated }}
                </v-col>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col v-for="n in 3" cols="12" :key="n">
                        <PlacementChecklistPhase
                            :phase="n"
                            :placement="placement"
                            :documentChecklist="documentChecklist"
                            :inEditMode="inEditMode"
                            :key="componentKey"
                        ></PlacementChecklistPhase>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-card-text
                        ><v-row dense>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="1000"
                                    v-model="documentChecklist.additional_info"
                                    :label="$t('fields.additionalInformation')"
                                    :key="componentKey"
                                ></TextArea>
                            </v-col> </v-row></v-card-text
                ></v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import TextArea from '@/components/trinkets/TextArea';
import PlacementDocumentChecklist from '../models/PlacementChecklist';
import PlacementChecklistPhase from './PlacementChecklistPhase.vue';

export default {
    name: 'DocumentChecklist',
    components: {TextArea, PlacementChecklistPhase},
    data: function () {
        return {
            documentChecklist: new PlacementDocumentChecklist({}),
            documentChecklistValidation: new PlacementDocumentChecklist({}, true),
            initialLoad: false,
            lockKey: 'placement-checklist',
            lockTimer: null,
            componentKey: 1,
            updated: '',
        };
    },
    props: ['placement', 'inEditMode'],
    watch: {},

    methods: {
        lockClick() {
            this.$emit('edit');
        },
        updateList() {
            let vm = this;
            this.$verify(this.$t('alerts.updateListQuestion'), (result) => {
                if (result) {
                    let checklistId = this.documentChecklist.id;
                    this.$APICall(
                        'post',
                        'placement-document-checklist-update/' + this.placement.id,
                        {checklistId},
                        (data, succes) => {
                            if (succes) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                if (!usableData.message) {
                                    vm.documentChecklist = usableData.document_checklist;
                                    vm.updated = usableData.updated;
                                    vm.componentKey += 1;
                                    clearInterval(vm.lockTimer);
                                    this.$removeLock(this, this.lockKey + '|' + this.documentChecklist.id);
                                } else {
                                    vm.$alert(vm.$t('alerts.noChecklistDefinedOnMaritimeObject'));
                                }
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        pullDocuments() {
            let vm = this;
            this.$verify(this.$t('alerts.updateListQuestion'), (result) => {
                if (result) {
                    let checklistId = this.documentChecklist.id;
                    this.$APICall(
                        'post',
                        'placement-document-checklist-pull/' + this.placement.id,
                        {checklistId},
                        (data, succes) => {
                            if (succes) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                if (!usableData.message) {
                                    vm.documentChecklist = usableData.document_checklist;
                                    vm.updated = usableData.updated;
                                    vm.componentKey += 1;
                                    clearInterval(vm.lockTimer);
                                    this.$removeLock(this, this.lockKey + '|' + this.documentChecklist.id);
                                } else {
                                    vm.$alert(vm.$t('alerts.noChecklistDefinedOnMaritimeObject'));
                                }
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        editClick() {
            this.$emit('edit');
        },

        backClick() {
            this.$router.go(-1);
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        this.$APICall('get', 'placement-document-checklists/' + this.placement.id, {}, (data, success) => {
            if (success) {
                let usableData = JSON.parse(JSON.stringify(data));
                vm.documentChecklist = usableData.item;
                vm.updated = usableData.updated;
                vm.componentKey += 1;
            } else {
                vm.inEditMode = false;
                vm.initialLoad = true;
            }
        });
    },
};
</script>

<style scoped></style>
